import React, { useEffect, useState } from "react";
import { getImageFile, setImageFile } from "../../services/storage/MediaStorage";


const CachedImage = ({ image, imgKey, width, imgClassName, ...otherProps }) => {
	const [src, setSrc] = useState(null);

	useEffect(() => {
		let isMounted = true;
		let objectUrl = null;

		const fetchAndCacheImage = async () => {
			if (!imgKey) {
				if (isMounted) setSrc(image);
				return;
			}

			try {
				const localBlob = await getImageFile(imgKey);

				if (localBlob instanceof Blob) {
					objectUrl = URL.createObjectURL(localBlob);
					if (isMounted) setSrc(objectUrl);
				} else {
					const response = await fetch(image);
					if (!response.ok) throw new Error("Image fetch failed");

					const blob = await response.blob();

					await setImageFile(imgKey, blob);

					objectUrl = URL.createObjectURL(blob);
					if (isMounted) setSrc(objectUrl);    
				}
			} catch (error) {
				console.error("Image load failed", error);
				if (isMounted) setSrc(image);
			}
		};

		fetchAndCacheImage();

		return () => {
			isMounted = false;
			if (objectUrl) URL.revokeObjectURL(objectUrl);
		};
	}, [imgKey, image]);

	if (!src) return null;

	return (
		<img
			loading="lazy"
			width={width}
			className={imgClassName}
			src={src}
			alt=""
			{...otherProps}
		/>
	);
};

export default CachedImage;
